// @ts-nocheck
import { useNavigate } from "react-router-dom";
import { useState, useEffect, useContext, createContext } from "react";
import { useAppDispatch, useAppSelector } from "../../hooks/useRedux";
import { logoutUser } from "../../store/userSlice";
import {
  fetchCoachOwnerProfile,
  updateProfilePicture,
} from "../../store/postsSlice";
import { BASE_URL } from "../../Constants/BaseUrl";
import axios from "axios";
import SkeletonLoader from "../../components/SkeletonLoader";
import ImagePicker from "../../components/ImagePicker";
import { toast } from "react-toastify";
import { Settings } from "lucide-react";
import EditCoachProfileModal from "../../components/EditCoachProfileModal";

const CoachProfile = () => {
  const [showImagePicker, setShowImagePicker] = useState(false);
  const [refreshing, setRefreshing] = useState(false);
  const [text, setText] = useState("");
  const [add, setAdd] = useState(false);
  const [buttonLoading, setButtonLoading] = useState(false);
  const dispatch = useAppDispatch();
  const { userPosts, loading, error } = useAppSelector((state) => state.posts);
  const user = useAppSelector((state) => state.user);
  const navigate = useNavigate();
  const userId = user?.user_id?.toString();
  console.log("coach id", userId);
  const [showSettings, setShowSettings] = useState(false);
  const userDetails = useAppSelector((state) => state.posts.coachOwnProfile);
  const [profilePicLoading, setProfilePicLoading] = useState(false);

  console.log(userDetails, "Cochownprofile");

  const handleLogout = () => {
    dispatch(logoutUser());
  };

  useEffect(() => {
    if (userId) dispatch(fetchCoachOwnerProfile(userId));
  }, [dispatch, userId]);

  const onRefresh = () => {
    if (userId) {
      setRefreshing(true);
      dispatch(fetchCoachOwnerProfile(userId)).finally(() =>
        setRefreshing(false),
      );
    }
  };

  if (loading) {
    return (
      <div className="min-h-screen p-4 bg-black text-white">
        <SkeletonLoader />
      </div>
    );
  }

  return (
    <div
      className="min-h-screen p-4 bg-black text-white"
      onScroll={() => onRefresh()}
    >
      <div className="flex justify-end">
        <button
          className="p-2 bg-black text-white rounded hover:bg-gray-600"
          onClick={() => setShowSettings(true)}
        >
          <Settings className="w-8 h-8" />
        </button>
      </div>

      {/* Header */}
      <div className="flex flex-col items-center py-6">
        <div className="relative">
          <img
            // src={
            //   userDetails?.profile_picture
            //     ? `${BASE_URL}/${userDetails.profile_picture}`
            //     : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQfj3Bm37Nn_rBQHkIzxnpmGMv3AnLWNYvA1_GwXzebfQ7rxLHl0fRsKo6mIi1SmoOiCL4&usqp=CAU"
            // }
            src={
              userDetails?.profile_picture?.startsWith("https")
                ? userDetails.profile_picture
                : userDetails?.profile_picture
                  ? `${BASE_URL}/${userDetails.profile_picture}`
                  : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQfj3Bm37Nn_rBQHkIzxnpmGMv3AnLWNYvA1_GwXzebfQ7rxLHl0fRsKo6mIi1SmoOiCL4&usqp=CAU"
            }
            alt="Profile"
            className="w-36 h-36 rounded-full border-2 border-white cursor-pointer hover:opacity-80 transition-opacity duration-200 group mb-4"
            onClick={() => setShowImagePicker(true)}
          />
          {profilePicLoading && (
            <div className="absolute inset-0 bg-black bg-opacity-40 flex justify-center items-center rounded-full">
              <div className="animate-spin rounded-full h-8 w-8 border-t-2 border-b-2 border-white"></div>
            </div>
          )}
        </div>
        <div className="text-center">
          <h2 className="text-xl font-semibold text-white">
            {userDetails?.coach_info?.first_name}{" "}
            {userDetails?.coach_info?.last_name}
          </h2>
          <p className="text-md text-white mt-1">
            {userDetails?.coach_info?.college}
          </p>
          <p className="text-md text-white mt-1">
            {userDetails?.coach_info?.sport_name}
          </p>
          <div className="flex justify-center gap-12 mt-4">
            <div className="text-center">
              <p className="text-lg font-semibold text-white">0</p>
              <p className="text-sm text-white">Followers</p>
            </div>
            <div className="text-center">
              <p className="text-lg font-semibold text-white">0</p>
              <p className="text-sm text-white">Following</p>
            </div>
          </div>
        </div>
      </div>

      {/* Posts Grid */}
      <div className="grid grid-cols-3 gap-2 mt-10">
        {userDetails?.posts?.length === 0 ? (
          <div className="col-span-3 flex justify-center items-center mt-12">
            <p className="text-lg text-white">No posts yet.</p>
          </div>
        ) : (
          userDetails?.posts?.map((item) => {
            if (!item) return null;
            // const imageUrl = item.image_url
            //   ? `${BASE_URL}${item.image_url}`
            //   : null;
            // const videoUrl = item.video_url
            //   ? `${BASE_URL}${item.video_url}`
            //   : null;
            const imageUrl = item.image_url?.startsWith("https")
              ? item.image_url
              : item.image_url
                ? `${BASE_URL}/${item.image_url}`
                : null;

            const videoUrl = item.video_url?.startsWith("https")
              ? item.video_url
              : item.video_url
                ? `${BASE_URL}/${item.video_url}`
                : null;
            if (!imageUrl && !videoUrl) return null;

            return (
              <div
                key={item.post_id}
                className="relative aspect-square overflow-hidden rounded-md cursor-pointer"
              >
                {imageUrl ? (
                  <img
                    src={imageUrl}
                    alt="Post"
                    className="w-full h-full object-cover"
                    onLoad={() => console.log("Image loaded")}
                    onClick={() =>
                      navigate("/post-preview", {
                        state: { currentPost: item, posts: userDetails?.posts },
                      })
                    }
                  />
                ) : (
                  <video
                    src={videoUrl}
                    className="w-full h-full object-cover"
                    onLoad={() => console.log("Video loaded")}
                    onClick={() =>
                      navigate("/post-preview", {
                        state: { currentPost: item, posts: userDetails?.posts },
                      })
                    }
                  />
                )}
              </div>
            );
          })
        )}
      </div>

      {/* Settings Modal (Simulated) */}
      <EditCoachProfileModal
        navigation={navigation}
        userDetails={userDetails}
        visible={showSettings}
        // color={color}
        setModalVisible={() => setShowSettings(false)}
      />
      <ImagePicker
        show={showImagePicker}
        onClose={() => setShowImagePicker(false)}
        onImageSelected={(file) => {
          setProfilePicLoading(true);
          dispatch(updateProfilePicture(file))
            .unwrap()
            .then(() => {
              toast.success("Profile picture updated!");
            })
            .catch((error) => {
              toast.error(error || "Failed to update profile picture");
            })
            .finally(() => {
              setProfilePicLoading(false);
            });
        }}
        // profileImageUri={
        //   userDetails?.profile_picture
        //     ? `${BASE_URL}/${userDetails?.profile_picture}`
        //     : "https://encrypted-tbn0.gstatic.com/images?q=trbn:ANd9GcQfj3Bm37Nn_rBQHkIzxnpmGMv3AnLWNYvA1_GwXzebfQ7rxLHl0fRsKo6mIi1SmoOiCL4&usqp=CAU"
        // }
        profileImageUri={
          userDetails?.profile_picture?.startsWith("https")
            ? userDetails.profile_picture
            : userDetails?.profile_picture
              ? `${BASE_URL}/${userDetails.profile_picture}`
              : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQfj3Bm37Nn_rBQHkIzxnpmGMv3AnLWNYvA1_GwXzebfQ7rxLHl0fRsKo6mIi1SmoOiCL4&usqp=CAU"
        }
      />
    </div>
  );
};

export default CoachProfile;
